﻿import { NamedValueResponse } from '../../../shared/models/named-value-response.model'

export class Hour extends NamedValueResponse {
}